<template>
    <div :class="['sub-nav']">
        <scrollable-widget
            arrow-bg-color="var(--secondary)"
            arrow-fg-color="var(--gray-dark)"
            :class="['d-none d-sm-flex']"
        >
            <b-navbar>
                <b-navbar-nav>
                    <b-nav-item
                            v-for="item in routes"
                            :key="item.label"
                            :to="item.route"
                            active-class="active"
                            v-if="item.access"
                    >
                        {{ item.label }}
                    </b-nav-item>
                </b-navbar-nav>
            </b-navbar>
        </scrollable-widget>
        <b-navbar v-if="hasAccess" class="d-sm-none flex-grow-1 pr-0">
            <b-navbar-nav class="w-100 justify-content-between">
                <div class="d-flex justify-content-between">
                    <b-nav-item-dropdown no-caret>
                        <template #button-content>
                            <font-awesome-icon
                                :icon="['far', 'bars']"
                                size="lg"
                                class="text-dark"
                            >
                            </font-awesome-icon>
                        </template>
                        <b-dropdown-item
                                v-for="item in routes"
                                :key="item.label"
                                :to="item.route"
                                active-class="active"
                                v-if="item.access"
                        >
                            {{ item.label }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-text class="ml-2 py-1 px-1 text-dark">{{ activeLink }}</b-nav-text>
                </div>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>

<script>
import RoutePermissionsMixin from '@/components/Nav/RoutePermissionsMixin';
import ScrollableWidget from '@/components/Widgets/ScrollableWidget';

export default {
  name: 'Organisation-Navbar',
  components: {
    ScrollableWidget,
  },
  mixins: [RoutePermissionsMixin],
  data() {
    return {
      routes: [
        {
          label: 'Organisation Chart',
          route: { name: 'orgChart' },
        },
        /*
        {
          label: 'User management',
          route: { name: 'users', children: [{ name: 'usersAdd' }] },
        },
        */
      ],
    };
  },
  computed: {
    hasAccess() {
      return true;
    },
    activeLink() {
      const routeName = this.$route.name;
      const activeRoute = this.routes.find(item => {
        if  (item.route.name === routeName) {
          return true;
        }

        if (item.route.children) {
          return item.route.children.find(child => child.name === routeName)
        }
      });

      return activeRoute ? activeRoute.label : null;
    },
  }
};
</script>
